import Api from '../api/api';
import User from '../user/user';
import CookieHelper from '../helpers/cookie-helper';
import NavbarDisplay from '../navbar/navbar-display';
import LoginModalHelper from '../helpers/login-modal-helper';
import {chat} from '../../../lucky-balls/js/chat';

class Auth {

    /**
     * Login Constructor.
     *
     * @param api Api
     */
    constructor(api) {
        this._api = api;
        this._navbar = new NavbarDisplay();
        this._4hours = 4000;
    }

    /**
     * Login user.
     *
     * @param user: User
     * @returns void
     */
    login(user) {

        let self = this;
        this._api.send('/login', {'username': user.username, 'password': user.password}, (response) => {
        
            if (!response.Data) {
                LoginModalHelper.logErorr(response.ErrorText);
            } else {
                let now = new Date();
                let time = now.getTime();
                // set time 4 hours ahead from now
                time += 3600 * self._4hours;
                now.setTime(time);
                document.cookie ='uName=' + response.Data.AuthUserResponse[0]['Username'] + ';path=/; expires=' + now.toUTCString();
                window['token'] = response.Data.AuthUserResponse[0]['SessionID'];
                document.cookie = 'token=' + response.Data.AuthUserResponse[0]['SessionID'] + ';path=/; expires=' + now.toUTCString();
                document.cookie = 'currency=' + response.Data.AuthUserResponse[0]['Currency'] + ';path=/; expires=' + now.toUTCString();
                self._navbar.showLogedIn(user, response);
                LoginModalHelper.closeModal();
                let getTickets = new CustomEvent("get_tickets_no_stats");
                window.dispatchEvent(getTickets);
                if (!/terminal/.test(window.location.href)) {
					chat(response.Data.AuthUserResponse[0]['SessionID']);
				}
            }
        }, (reject) => {
            LoginModalHelper.logErorr('Login failed.');
            console.log('Login failed.' + JSON.parse(reject));
        });
    }


    /**
     * Logout user.
     *
     * @returns void
     */
    logout() {

        let username = CookieHelper.get('uName');
        let self = this;
        this._api.send('/logout', {'username': username}, function (response) {
            let now = new Date();
            let time = now.getTime();
            // set time 4 hours behind in the past (removes cookie).
            time -= 3600 * self._4hours;
            now.setTime(time);
            if (!response.Data) {
                document.cookie ='uName=' + username + ';path=/; expires=' + now.toUTCString();
                document.cookie ='token=' +  window['token'] + ';path=/; expires=' + now.toUTCString();
                document.cookie = 'currency=' + CookieHelper.get('currency') + ';path=/; expires=' + now.toUTCString();
                self._navbar.showLogedOut();
                let getTickets = new CustomEvent("get_tickets_no_stats");
                window.dispatchEvent(getTickets);
            } 
        }, () => {
            console.log('Logout failed.');
        });
    }
}


export default Auth;



//////////////////
// WEBPACK FOOTER
// ./src/games/horse-racing/js/auth/auth.js
// module id = 1572
// module chunks = 7